import React from 'react';
import { Input } from 'reactstrap';
import withLoader from 'components/organisms/withLoader';
import { format } from 'date-fns';
import Pagination from 'components/molecules/paginationTransition';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import useClinicalNotes, { PER_PAGE } from 'utils/useClinicalNotes';
import { isCcmActionAllowedStatus } from 'utils/userTypeHelper';
import TableActions from '../components/tableActions';
import CcmNarrativeModal from '../components/narrativeTemplates/modal';

const ClinicalNotes = () => {
  const patient = useSelector((state) => state.ccmPatientDetails.patient);
  const canEditPage = isCcmActionAllowedStatus(patient?.profile?.ccmStatus);

  const {
    narrativeModalOpen,
    setNarrativeModalOpen,
    patientGuid,
    row,
    setRow,
    loading,
    cacheLoading,
    items,
    isValid,
    messageErrors,
    cancel,
    createNewRow,
    setPage,
    count,
    page,
    save,
  } = useClinicalNotes();

  const rowIsSaved = !Object.keys(row).length;
  return (
    <>
      <h3 className="ccm-table-section__h4">Clinical Notes Logged</h3>
      {narrativeModalOpen && (
        <CcmNarrativeModal
          isOpen={narrativeModalOpen}
          closeModal={() => {
            setNarrativeModalOpen(false);
          }}
          onSubmit={(value) => setRow({ ...row, note: value })}
          patientGuid={patientGuid}
        />
      )}
      {withLoader(
        loading || cacheLoading,
        <>
          <div className="table-outer table-custom-scrollbar">
            <table
              cellSpacing="0"
              cellPadding="0"
              className="table-border clinical-notes-table"
            >
              <thead>
                <tr>
                  <th>Date/Time</th>
                  <th>Care Agent</th>
                  <th>Note/Comment</th>
                </tr>
              </thead>
              <tbody>
                {!!items.length &&
                  items.map((el, index) => (
                    <tr key={index}>
                      <td>
                        {el.createdAt
                          ? format(new Date(el.createdAt), 'LLL dd yyyy p')
                          : ''}
                      </td>
                      <td>
                        {`${el.author.title || ''} ${
                          el.author.firstName || ''
                        } ${el.author.lastName || ''} `}
                      </td>
                      <td>
                        <div className="note">{el.note}</div>
                      </td>
                    </tr>
                  ))}

                {canEditPage && !rowIsSaved && (
                  <tr
                    className={classNames({
                      'table-column__input': true,
                      'table-column__input--error':
                        row.diagnoseGuid && !isValid,
                    })}
                  >
                    <td colSpan="3">
                      <div>
                        <div className="table-column__input-container">
                          <Input
                            type="textarea"
                            value={row.note}
                            placeholder="Input your note here..."
                            onChange={(e) =>
                              setRow({ ...row, note: e.target.value })
                            }
                          />
                          {row.note && (
                            <div className="table-column__character-length">
                              Character Count: {row.note.length}
                            </div>
                          )}
                        </div>
                        {messageErrors.note ? (
                          <div className="table-column__error">
                            {messageErrors.note}
                          </div>
                        ) : null}
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          <TableActions
            save={save}
            cancel={cancel}
            new={createNewRow}
            rowIsSaved={rowIsSaved}
            showTemplateButton={!rowIsSaved}
            onClickTemplateButton={() => setNarrativeModalOpen(true)}
          />

          <div className="ccm-table-section__pagination">
            <Pagination
              title=""
              page={page}
              pageTotal={items.length}
              itemsPerPage={PER_PAGE}
              total={count}
              handleFirstClick={() => setPage(1)}
              handleLastClick={() => setPage(Math.ceil(count / PER_PAGE))}
              handlePrevClick={() => setPage(page - 1)}
              handleNextClick={() => setPage(page + 1)}
              handleGoToPage={(numberPage) => setPage(numberPage)}
            />
          </div>
        </>,
      )}
    </>
  );
};

export default ClinicalNotes;
